module.exports = __webpack_public_path__ + "static/media/payoneer.bcd09022.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/payoneer.png
// module id = 368
// module chunks = 0